export default __webpack_public_path__ + "c51d021b82cb640e465d85ac1f30c70e.svg";